import { useCallback, useSyncExternalStore } from 'react';
import type { SceneStore } from '@os/doc';
import { worldToScreen, type Camera } from '@os/engine';
import type { Peer } from './usePresence';

/** Outlines, in each peer's colour, the objects they have selected (screen space, follows rotation). */
export function RemoteSelections({ peers, store, camera }: { peers: readonly Peer[]; store: SceneStore; camera: Camera }) {
  const subscribe = useCallback((cb: () => void) => store.subscribeList(cb), [store]);
  useSyncExternalStore(subscribe, () => store.list());
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-10 overflow-hidden">
      {peers.flatMap((p) =>
        p.selection.map((id) => {
          const o = store.getObject(id);
          if (!o) return null;
          const c = worldToScreen(camera, { x: o.x + o.w / 2, y: o.y + o.h / 2 });
          const [w, h] = [o.w * camera.z, o.h * camera.z];
          return (
            <div
              key={`${p.clientId}:${id}`}
              data-remote-selection
              className="absolute left-0 top-0 rounded-sm"
              style={{
                width: `${w}px`,
                height: `${h}px`,
                transform: `translate(${c.x - w / 2}px, ${c.y - h / 2}px) rotate(${o.rotation}deg)`,
                outline: `2px solid ${p.user.c}`,
                outlineColor: p.user.c,
              }}
            />
          );
        }),
      )}
    </div>
  );
}
